import React from "react";
import styled from "styled-components";
import { Row, Col } from 'react-bootstrap';



function FormErrorMessage(props){
  const MessageContianer = styled(Row)`
    display:flex;
    margin:16px 0;
    padding:16px 24px;
    justify-content:center;
    align-items:center;
    max-width:${props.width};
    background-color: #FFEBE9;
    border: 1px solid #FFC1C0;
    border-radius: 5px
  `;
  const Span = styled.span`
    cursor:pointer;
    color: red
  `;
  return (
    <MessageContianer  style={{display: props.showMessage? "":"none"}}>
      <Col className={"mx-1 px-0"}>
        <span style={{textAlign:'left'}}> {props.message}</span>
      </Col>
      <Col md={'auto'} className={"mx-1 px-0"}>
        <Span onClick={()=>{props.toggleMessage(false)}}
          className="fa fa-times"
        ></Span>
      </Col>
    </MessageContianer>
  );
}
export default FormErrorMessage;